import {Component, Input, OnInit} from '@angular/core';
import {EnumerationService} from '../../services/enumeration.service';
import {ExcRestService} from 'exc-rest-v2';

@Component({
  selector: 'app-case-select',
  templateUrl: './case-select.component.html',
  styles: [
  ]
})
export class CaseSelectComponent implements OnInit {

  constructor(public enumSvc: EnumerationService,
              public excRest: ExcRestService,) {
  }

  ngOnInit(): void {
  }

}
